//provided to make spelling easier.
export const COLOR_VISION = {
  NONE: 'none',
  PROTANOPIA: 'Protanopia',
  DEUTERANOPIA: 'Deuteranopia',
  TRITANOPIA: 'Tritanopia',
  ACHROMATOPSIA: 'Achromatopsia'
};
